import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class WorkorderApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/workorder' + path, queryMap);
  }

  postWordOrder(
    busSeatID: number,
    issueType: number,
    message: string,
    image: any,
    sender: string,
  ) {
    const url = this.buildurl('/workorder');
    const body = {
      bus_seat_id: busSeatID,
      issue_type: issueType,
      message,
      image,
      sender,
    };
    return this.http.post(url, body);
  }

  findSeatInfo() {
    const url = this.buildurl('/getseatinfo');
    return this.http.fget(url);
  }

  // findProblem(platformName: string, la: string) {
  //   const q = { platform_name: platformName, la };
  //   const url = this.buildurl('/get/problem', q);
  //   return this.http.fget(url);
  // }

  findTicket(account: string, status: string) {
    const url = this.buildurl('/get/workorder', { account, status });
    return this.http.fget(url);
  }

  getTicket(id: number) {
    const url = this.buildurl(`/getdialogs/${id}`);
    return this.http.fget(url);
  }

  closeTicket(id: number) {
    const url = this.buildurl(`/completion/${id}`);
    return this.http.fget(url);
  }

  postUserreply(id: number, message: string, image: any) {
    const url = this.buildurl(`/userreply/${id}`);
    const body = {
      message,
      image,
    };
    return this.http.post(url, body);
  }

  // postYoutubeTodo(
  //   type: string,
  //   bus_id: number,
  //   platform_id: number,
  //   bus_account_id: number
  // ) {
  //   const url = this.buildurl('/useryttodo');
  //   const body = {
  //     type,
  //     bus_id,
  //     platform_id,
  //     bus_account_id,
  //   };
  //   return this.http.post(url, body);
  // }

  findWorkProblems(
    platform_name: string,
    status: string,
    la: string,
    page: number,
    page_size: number,
  ) {
    const q = { platform_name, status, la, page, page_size };
    const url = this.buildurl('/get/work/problems', q);
    return this.http.fget(url);
  }

  // createWorkPrblemdetail(
  //   bus_id: number,
  //   bus_seat_id: number,
  //   platform_id: number,
  //   bus_account_id: number,
  //   order_id: string,
  //   work_problem_re: number,
  //   customer_url: string,
  //   customer: string
  // ) {
  //   const body = {
  //     bus_id,
  //     bus_seat_id,
  //     platform_id,
  //     bus_account_id,
  //     order_id,
  //     work_problem_re,
  //     customer_url,
  //     customer,
  //   };
  //   const url = this.buildurl('/seat/workorder');
  //   return this.http.post(url, body);
  // }

  // solveWorkProblem(bus_seat_id: number, is_solve: number) {
  //   const url = this.buildurl('/update/seat/is_solve');
  //   const body = { bus_seat_id, is_solve };
  //   return this.http.put(url, body);
  // }

  // getWorkProbem(bus_seat_id: number) {
  //   const q = { bus_seat_id };
  //   const url = this.buildurl('/get/seat/workorder', q);
  //   return this.http.fget(url);
  // }

  // postQiniu(upload: any) {
  //   const url = this.buildurl('/qiniu');
  //   const body = new FormData();
  //   body.append('upload', upload);
  //   return this.http.post(url, body);
  // }

  checkProblemHelp(id: number) {
    const url = this.buildurl(`/check/work/problemsre/${id}`);
    return this.http.fget(url);
  }

  getNoReplyWorkorderCount() {
    const url = this.buildurl('/get/noworkorder');
    return this.http.fget(url);
  }

  postWorkorderFeedback(
    work_id: number,
    user_id: number,
    handler_id: number,
    bus_id: number,
    star_level: string,
    // overall_eval: string,
    is_resolved: boolean,
    feedback: string,
    service_eval: string,
    product_eval: string,
    service_star_level: string,
    product_star_level: string,
  ) {
    const body = {
      work_id,
      user_id,
      handler_id,
      bus_id,
      star_level,
      // overall_eval,
      is_resolved,
      feedback,
      service_eval,
      product_eval,
      service_star_level,
      product_star_level,
    };
    const url = this.buildurl('/feedback');
    return this.http.post(url, body);
  }

  changeProcessCompleted(id: number) {
    const url = this.buildurl(`/confirm/${id}`);
    return this.http.post(url, {});
  }
}
